<template>
  <nav class="main-nav">
    <ul class="main-menu">
      <li class="main-menu-item">
        <router-link id="faq-button" to="/faq">FAQ</router-link> 
      </li>
      <li class="main-menu-item"><router-link id="pony-search-button" to="/pony-search">Search Ponies</router-link>
      </li>
      <li v-if="isAuthenticated" class="main-menu-item">
        <router-link id="herd-button" :to="`/herd/${user.id}`">Herd</router-link>
      </li>
      <li v-if="isAuthenticated" class="main-menu-item">
        <router-link id="wishlist-button" :to="`/wishlist/${user.id}`">Wishlist</router-link>
      </li>
      <li v-if="isAuthenticated" class="main-menu-item">
        <router-link id="favorites-button" :to="`/favorite/${user.id}`">Favorites</router-link>
      </li>
      <li v-if="isAuthenticated" class="main-menu-item">
        <router-link id="dashboard-button" class="active" to="/dashboard">My Account</router-link>
      </li>
      <li v-if="isAuthenticated" class="main-menu-item">
        <button id="logout-button" @click="logout" class="nav-button">Logout</button>
      </li>
      <li v-if="!isAuthenticated" class="main-menu-item">
        <router-link id="login-button" to="/login">Login</router-link>
      </li>
      <li v-if="!isAuthenticated" class="main-menu-item">
        <router-link id="register-button" to="/register">Register</router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'NavigationMain',
  props: {
    user: {
      type: Object
    }
  },
  computed: {
    isAuthenticated() {
      return this.user && Object.keys(this.user).length;
    }
  },
  methods: {
    logout() {
      this.$emit('loggedOut');
    }
  }
};
</script>

<style lang="scss" scoped>

@import '../../assets/sass/config';

.main-nav {
  padding: 10px 0;
}

.main-menu {
  padding: 0 10px 0 0;
}

.main-menu-item {
  padding: 0 5px;
  margin: 0;
  display: inline-block;
  position: relative;

  a,
  .nav-button {
    display: block;
    font-size: 14px;
    text-decoration: none;
    padding: 5px 15px;
    border-radius: 5px;
    color: $text-color;
    transition: color 0.3s, background-color 0.3s;

    &:hover {
      text-decoration: none;
      background-color: $teal;
      color: #fff;
    }
  }

  .active {
    background-color: $accent-color;
    color: #fff;

    &:hover {
      background-color: $teal;
    }
  }

  .sub-menu {
    z-index: 20;
    position: absolute;
    left: 5px;
    top: 100%;
    list-style: none;
    padding: 0;
    border-radius: 5px;
    overflow: hidden;
    display: block;
    opacity: 0;
    transition: opacity .3s, max-height .3s;
    max-height: 0;

    li {
      padding: 0;
      margin: 0;
      text-align: left;

      &:first-child {
        padding-top: 10px;
        
        a {
          border-radius: 5px 5px 0 0;
        }
      }

      a {
        width: 150px;
        background-color: $accent-color;
        color: #fff;
        border-radius: 0;
        padding: 10px 15px;

        &:hover {
          background-color: $teal;
          color: #fff;
        }
      }
    }
  }

  &:hover {
    .sub-menu {
      opacity: 1;
      max-height: 1000px;
    }
  }
}
</style>
